export default __webpack_public_path__ + "static/media/id-check.ea65df3a.png";